
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/partners",
      function () {
        return require("private-next-pages/media/partners/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/media/partners"])
      });
    }
  